<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{ title }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <fa-icon icon="times" aria-hidden="true"></fa-icon>
  </button>
</div>

<div class="modal-body">
  <myp-segmented-bar class="d-block m-b-15" [white]="true" [options]="osOptions" (selected)="onOsSelected($event)"></myp-segmented-bar>

  @if (!filteredVersions?.length) {
    <div class="text-center m-y-30 gothic">No versions available for the selected system.</div>
  }
  @for (v of filteredVersions; track v.url) {
    <myp-list-item
      [item]="v"
      [title]="v.title"
      [subData]="v.subData"
      [metadata]="v.metadata"
      [showImage]="false"
      [includeChevron]="false"
      [hoverState]="false"
      [includeBottomBorder]="true"
      (itemClicked)="download(v)"
    >
      <div class="button-content">
        <button type="button" class="circle-icon-btn bg-transparent border-0 p-0" [ngbTooltip]="'Download'" (click)="download(v); $event.stopPropagation()">
          <fa-icon icon="download" class="action" aria-hidden="true"></fa-icon>
          <span class="sr-only">Download</span>
        </button>
      </div>
    </myp-list-item>
  }
</div>
